import React, { createContext, useContext, useState, useEffect, useCallback } from "react";

const STORAGE_KEY = "tidle_dev_pro";

function readStored() {
  if (typeof window === "undefined") return null;
  try {
    const v = localStorage.getItem(STORAGE_KEY);
    if (v === "true") return true;
    if (v === "false") return false;
    return null;
  } catch {
    return null;
  }
}

const DevSubscriptionOverrideContext = createContext({
  devProOverride: null,
  setDevProOverride: () => {},
});

export function DevSubscriptionOverrideProvider({ children }) {
  const [devProOverride, setDevProOverrideState] = useState(readStored);

  useEffect(() => {
    setDevProOverrideState(readStored);
  }, []);

  const setDevProOverride = useCallback((value) => {
    setDevProOverrideState(value);
    try {
      if (value === null) {
        localStorage.removeItem(STORAGE_KEY);
      } else {
        localStorage.setItem(STORAGE_KEY, value ? "true" : "false");
      }
    } catch (e) {
      console.warn("[DevSubscriptionOverride] localStorage write failed", e);
    }
  }, []);

  return (
    <DevSubscriptionOverrideContext.Provider value={{ devProOverride, setDevProOverride }}>
      {children}
    </DevSubscriptionOverrideContext.Provider>
  );
}

export default DevSubscriptionOverrideContext;
